// @flow

import _ from 'lodash';

import AppDispatcher from 'PMT/flux/AppDispatcher';

import ActionTypes from 'constants/ActionTypes';

import PMTApiProAccount from 'PMT/api/ApiProAccount';

import {
  ProAccountStore,
  RestaurantStore,
  SessionStore
} from 'stores';

import ApiError from 'PMT/entities/ApiError';
import Restaurant from 'PMT/entities/Restaurant';

import {
  ProAccount,
  ProAccountsList,
  ProRole,
  ProPermission,
  ProPermissionsList,
  ProDomainsList,
  ProDomain
} from 'PMT/entities/security';

export default class ProAccountAction {

  //
  // Create account
  //

  static createAccount(proAccount: ProAccount) {
    PMTApiProAccount.postAccount(
      proAccount,
      ProAccountAction.receiveCreateAccount,
      ProAccountAction.receiveCreateAccountError
    );
  }

  static receiveCreateAccount(proAccount: ProAccount) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_CREATE_SUCCESS,
      proAccount
    });
  }

  static receiveCreateAccountError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_CREATE_FAILURE,
      apiError
    });
  }

  static forgotPassword(email) {
    PMTApiProAccount.getRecoverPassword(
      email,
      ProAccountAction.forgotPasswordSuccess,
      ProAccountAction.forgotPasswordError
    );
  }

  static forgotPasswordSuccess(data) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_FORGOT_PASSWORD_SUCCESS,
      data
    });
  }

  static forgotPasswordError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_FORGOT_PASSWORD_FAILURE,
      apiError
    });
  }

  //
  // Retrieve account
  //

  static retrieveMeAccount() {
    let domainId = ProAccountStore.getSelectedProDomainId();

    if (_.isNil(domainId)) {
      domainId = SessionStore.getProDomainId();
    }

    let restaurantId = RestaurantStore.getRestaurantId();

    if (_.isNil(restaurantId)) {
      restaurantId = SessionStore.getRestaurantId();
    }

    PMTApiProAccount.getAccountData(
      domainId,
      restaurantId,
      ProAccountAction.receiveRetrieveMeAccount,
      ProAccountAction.receiveRetrieveMeAccountError
    );
  }

  static receiveRetrieveMeAccount(proAccount: ProAccount, restaurant: Restaurant, proDomain: ProDomain) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.PRO_ACCOUNT_GET_ME_SUCCESS,
      proAccount,
      restaurant,
      proDomain
    });
  }

  static receiveRetrieveMeAccountError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_GET_ME_FAILURE,
      apiError
    });
  }


  static retrieveAccount(accountId: string) {
    PMTApiProAccount.getAccount(
      accountId,
      ProAccountAction.receiveRetrieveAccount,
      ProAccountAction.receiveRetrieveAccountError
    );
  }

  static receiveRetrieveAccount(proAccount: ProAccount) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_GET_SUCCESS,
      proAccount
    });
  }

  static receiveRetrieveAccountError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_GET_FAILURE,
      apiError
    });
  }

  //
  // Update account
  //

  static updateAccount(proAccount: ProAccount) {
    PMTApiProAccount.putAccount(
      proAccount,
      ProAccountAction.receiveUpdateAccount,
      ProAccountAction.receiveUpdateAccountError
    );
  }

  static receiveUpdateAccount(proAccount: ProAccount) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_UPDATE_SUCCESS,
      proAccount
    });
  }

  static receiveUpdateAccountError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_CREATE_FAILURE,
      apiError
    });
  }

  //
  // Delete account
  //

  static deleteAccount(proAccount: ProAccount) {
    PMTApiProAccount.deleteAccount(
      proAccount,
      ProAccountAction.receiveDeleteAccount,
      ProAccountAction.receiveDeleteAccountError
    );
  }

  static receiveDeleteAccount(proAccount: ProAccount) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_DELETE_SUCCESS,
      proAccount
    });
  }

  static receiveDeleteAccountError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_DELETE_FAILURE,
      apiError
    });
  }

  //
  // Retrieve domains
  //

  static retrieveAccountDomains(proAccount: ProAccount, loadRole: boolean = true, loadRestaurantsGroup: boolean = false, loadRestaurantsGroupChildren: boolean = false) {
    PMTApiProAccount.getAccountDomains(
      proAccount,
      loadRole,
      loadRestaurantsGroup,
      loadRestaurantsGroupChildren,
      ProAccountAction.receiveAccountDomains,
      ProAccountAction.receiveAccountDomainsError
    );
  }

  static receiveAccountDomains(proAccount: ProAccount, proDomainsList: ProDomainsList) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_GET_DOMAINS_SUCCESS,
      proAccount,
      proDomainsList
    });
  }

  static receiveAccountDomainsError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PRO_ACCOUNT_GET_DOMAINS_FAILURE,
      apiError
    });
  }

  //
  //
  //

  static changeProDomain(proDomain: ProDomain) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.CHANGE_PRO_DOMAIN,
      proDomain
    });
  }
}
